var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"autumn"}},[_c('div',{staticClass:"top"}),_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"maples"},[_c('img',{attrs:{"src":'./img/maples.png'}}),_c('img',{attrs:{"src":'./img/maples.png'}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }